export { default } from "./Error";
